import mutations from './mutations'
import * as actions from './actions'
import * as getters from './getters'

const initialState = {
    categoriesWithProducts: [],
    products: [],
    categories: [],
    carts: [{ items: [], selectedClient: null }],
    activeCartIndex: 0,
    paymentMethods: [],
    customers: [],

    loading: false,
    error: null,
    currentShopId: null
}

export default {
    namespaced: true,

    state: initialState,

    getters: getters,

    actions: actions,

    mutations: mutations
}
